import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Checkmark = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="checkmark icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4142 3.17581C24.1953 3.95686 24.1953 5.22319 23.4142 6.00424L8 21.4185L0.585786 14.0042C-0.195262 13.2232 -0.195262 11.9569 0.585786 11.1758C1.36683 10.3948 2.63317 10.3948 3.41421 11.1758L8 15.7616L20.5858 3.17581C21.3668 2.39476 22.6332 2.39476 23.4142 3.17581Z"
    />
  </svg>
)
